module.exports = __webpack_public_path__ + "static/appointer-marke-4069669c0420fe4074c806ea396d72f1.svg";